import React, { useState, useEffect } from 'react';
import eventEmitter, { EVENT_TYPES } from '../../EventEmitterService';
import analytics from '../../services/analytics';
import SoftReconnectionModal from './ReconnectionModalTypes/SoftReconnectionModal';
import HardReconnectionModal from './ReconnectionModalTypes/HardReconnectionModal';

const ReconnectionModal = () => {
  const [modalState, setModalState] = useState(null);

  useEffect(() => {
    const handleReconnecting = event => {
      analytics.trackAutoReconnectAttempted();
      setModalState('soft');
    };

    const handleReconnected = event => {
      analytics.trackReconnectSuccess();
      const interviewId = localStorage.getItem('interview_id');
      if (interviewId) {
        analytics.trackSessionReconnected(interviewId, 'auto');
      }
      setModalState(null);
    };

    const handleReconnectionFailed = event => {
      analytics.trackReconnectFailed();
      setModalState('hard');
    };

    eventEmitter.on(EVENT_TYPES.RECONNECTING, handleReconnecting);
    eventEmitter.on(EVENT_TYPES.RECONNECTED, handleReconnected);
    eventEmitter.on(EVENT_TYPES.RECONNECTION_FAILED, handleReconnectionFailed);

    return () => {
      eventEmitter.off(EVENT_TYPES.RECONNECTING, handleReconnecting);
      eventEmitter.off(EVENT_TYPES.RECONNECTED, handleReconnected);
      eventEmitter.off(EVENT_TYPES.RECONNECTION_FAILED, handleReconnectionFailed);
    };
  }, []);

  const handleHardRefresh = () => {
    analytics.trackManualReconnectClicked();
    const interviewId = localStorage.getItem('interview_id');
    if (interviewId) {
      analytics.trackSessionReconnected(interviewId, 'manual');
    }
    window.location.reload();
  };

  if (modalState === 'soft') {
    return <SoftReconnectionModal visible={true} />;
  }

  if (modalState === 'hard') {
    return (
      <HardReconnectionModal
        visible={true}
        onReconnect={handleHardRefresh}
      />
    );
  }

  return null;
};

export default ReconnectionModal;
